import {Linear} from 'gsap';
const PIXI = require('pixi.js');
const Shortcuts = require('../utils/Shortcuts');


module.exports = (tl, root, cont, delay, duration, setLabel, inLabel, outLabel, offLabel) => {

    if (!cont || !root) return;
    const sizes = require('../../DefaultProjectSize');

    const msk = new PIXI.Graphics();
    Shortcuts.rect(msk, 0, 0, sizes.width, sizes.height, 0xff0000);
    msk.pivot.x = sizes.width;

    cont.mask = msk;
    root.addChild(msk);

    tl.set(msk.pivot, {x: sizes.width});

    tl.to(msk.pivot, duration, {x: 0, ease: Linear.easeInOut}, setLabel + '+=' + delay);
    tl.to(msk.pivot, 0, {x: 0}, offLabel);
}


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/illustrations/AddWipeTimelineAtStart.js